module.exports = __webpack_public_path__ + "img/nyk_seating_chart.98fae48f.png";